<template>
  <el-dialog
    class="address-form"
    :title="title"
    :center="true"
    :visible.sync="showAddressModal"
    width="652px"
    appendToBody
    :show-close="false"
  >
    <el-form :model="addressForm" :rules="addressRules" ref="addressForm" label-width="130px">
      <el-form-item prop="district_id">
        <template v-slot:label>
          <span class="require"></span>
          <span>地址信息：</span>
        </template>
        <AreaSelect
          :provinceId="addressForm.province_id"
          :cityId="addressForm.city_id"
          :districtId="addressForm.district_id"
          @change="areaChange"
        ></AreaSelect>
      </el-form-item>
      <el-form-item prop="address">
        <template v-slot:label>
          <span class="require"></span>
          <span>详细地址：</span>
        </template>
        <el-input
          v-model="addressForm.address"
          placeholder="请输入详细地址，如道路，门牌号，校区，楼栋数，单元等"
          type="textarea"
          :rows="5"
        ></el-input>
      </el-form-item>
      <el-form-item prop="user_name">
        <template v-slot:label>
          <span class="require"></span>
          <span>收货人姓名：</span>
        </template>
        <el-input
          v-model="addressForm.user_name"
          placeholder="长度不超过25个字符"
          type="text"
          :maxlength="25"
          style="width: 290px"
        ></el-input>
      </el-form-item>
      <el-form-item prop="mobile">
        <template v-slot:label>
          <span class="require"></span>
          <span>手机号码：</span>
        </template>
        <el-input
          v-model="addressForm.mobile"
          placeholder="请输入手机号"
          type="text"
          :maxlength="11"
          @input="handleFormatMobile"
          style="width: 290px"
        ></el-input>
      </el-form-item>
    </el-form>
    <div class="default-wrap">
      <el-checkbox v-model="addressForm.is_default">设为默认地址</el-checkbox>
      <span class="tip">{{ tip }}</span>
    </div>
    <div class="pop-footer" slot="footer">
      <el-button type="primary" size="small" @click="confirmAddress"> 确定 </el-button>
      <el-button size="small" @click="showAddressModal = false">取消</el-button>
    </div>
  </el-dialog>
</template>
<script>
import AreaSelect from '@/components/AreaSelect.vue';
export default {
  name: 'AddressForm',
  components: { AreaSelect },
  props: {
    tip: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '创建地址',
    },
    onConfirm: {
      type: Function,
    },
    address: {
      type: Object,
    },
  },
  watch: {
    address(val) {
      if (val) {
        Object.keys(this.addressForm).forEach((key) => {
          if (val[key]) {
            if (key == 'is_default') {
              this.addressForm[key] = val[key] == 1;
            } else {
              this.addressForm[key] = val[key];
            }
          }
        });
      }
    },
  },
  data() {
    return {
      showAddressModal: false,
      addressForm: {
        province_id: '',
        city_id: '',
        district_id: '',
        address: '',
        zip_code: '',
        user_name: '',
        mobile: '',
        is_default: false,
      },
      addressRules: {
        district_id: [{ required: true, message: '地址信息不能为空', trigger: 'chnage' }],
        address: [{ required: true, message: '详细地址不能为空', trigger: 'blur' }],
        user_name: [{ required: true, message: '收货人姓名不能为空', trigger: 'blur' }],
        mobile: [
          {
            required: true,
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error('手机号码不能为空'));
              } else if (!/^[0-9]{11}$/.test(value)) {
                callback(new Error('手机号码格式错误'));
              } else {
                callback();
              }
            },
          },
        ],
        zip_code: [
          {
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (!value) {
                callback();
              } else if (!/^[0-9]{6}$/.test(value)) {
                callback(new Error('邮政编码格式错误'));
              } else {
                callback();
              }
            },
          },
        ],
      },
    };
  },
  methods: {
    handleFormatMobile() {
      this.addressForm.mobile = this.addressForm.mobile.replace(/[^\d]/g, '');
    },
    init() {
      this.addressForm.province_id = '';
      this.addressForm.city_id = '';
      this.addressForm.district_id = '';
      this.addressForm.address = '';
      this.addressForm.zip_code = '';
      this.addressForm.user_name = '';
      this.addressForm.mobile = '';
    },
    showForm() {
      this.showAddressModal = true;
      this.init();
    },
    areaChange(area) {
      this.addressForm.province_id = area.provinceId;
      this.addressForm.city_id = area.cityId;
      this.addressForm.district_id = area.districtId;
    },
    confirmAddress() {
      this.$refs['addressForm'].validate(async (valid) => {
        if (!valid) {
          return;
        }
        const params = {
          province_id: this.addressForm.province_id,
          city_id: this.addressForm.city_id,
          district_id: this.addressForm.district_id,
          address: this.addressForm.address,
          zip_code: this.addressForm.zip_code,
          user_name: this.addressForm.user_name,
          mobile: this.addressForm.mobile,
          is_default: this.addressForm.is_default ? 1 : 2,
        };
        if (this.onConfirm) {
          await this.onConfirm(params);
        } else {
          await this.$http.post('/api/app/address', params);
        }
        this.showAddressModal = false;
        this.$emit('success', this.addressForm);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.address-form {
  ::v-deep {
    .el-dialog {
      position: absolute;
      margin-top: 0 !important;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    .el-dialog__header {
      padding: 16px 0 20px 24px;
      text-align: left;
    }

    .el-dialog__title {
      line-height: 24px;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333;
    }

    .el-dialog__headerbtn {
      top: 37px;
      right: 50px;
    }

    .el-dialog__body {
      padding: 0 35px 0 16px;
    }

    .el-dialog__footer {
      padding: 24px 24px;
    }

    .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
      content: '';
    }

    .require {
      width: 6px;
      height: 6px;
      display: inline-block;
      margin-right: 6px;
      vertical-align: 4px;
      background-size: 100% 100%;
      background-image: url('~@/assets/images/common/require@2x.png');
    }

    .el-form-item__label {
      height: 21px;
      font-size: 15px;
      color: rgba(89, 89, 89, 1);
      line-height: 40px;
      padding-right: 10px;
      position: relative;
    }

    .el-form-item__content {
      line-height: 40px;
    }

    .el-select {
      width: 145px !important;
      &:last-child {
        margin-right: 0 !important;
      }

      .el-input {
        font-size: 15px;
        font-family: PingFangSC-Regular, PingFang SC;
      }
    }

    .el-form-item {
      margin-bottom: 24px;
    }

    .el-input__inner {
      height: 40px;
      line-height: 40px;
      font-size: 15px;
      color: #595959;
    }

    .el-checkbox {
      display: flex;
      align-items: center;
    }

    .el-checkbox__label {
      height: 21px;
      font-size: 15px;
      color: rgba(89, 89, 89, 1);
      line-height: 21px;
      padding-left: 8px;
    }

    .el-checkbox__input {
      height: 14px;
    }
  }

  .default-wrap {
    display: flex;
    align-items: center;
    padding-left: 130px;

    ::v-deep {
      .el-checkbox {
        margin-right: 8px;
      }
    }

    .tip {
      height: 15px;
      font-size: 12px;
      color: rgba(183, 183, 183, 1);
      line-height: 15px;
    }
  }

  .pop-footer {
    display: flex;
    flex-direction: row-reverse;
    .el-button {
      width: 68px;
      height: 36px;
      border-radius: 4px;
      margin-left: 10px;
    }
  }
}
</style>
